import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import {
  calculatePerimeterBuildingFootprint,
  showNotification,
} from '@/services/calculate'
import { updateGridRecord, addGridRecord } from '@/services/grid'
import { validateNumber } from '@/services/config'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '@/components/DynamicComponents/Admin/MasterData/GridRenderer/actionRendere'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import InputNumberEditor from '@/components/DynamicComponents/Renderers/inputNumberEditor'
import TextEditor from '@/components/DynamicComponents/Renderers/textEditor'
import bankModal from '@/components/DynamicComponents/Projects/BankModal'
import NumberRender from '@/components/DynamicComponents/Renderers/numberRenderer'
import { formatNumber } from '@/services/convert'

export default {
  props: ['grouping'],
  components: {
    'ag-grid-vue': AgGridVue,
    'save-as-bank': bankModal,
  },
  data: function() {
    const checkLength = (rule, value, callback) => {
      if (rule.field === 'area') {
        const reg = /^(?!$)\d{0,9}(?:\\d{9})?$/
        if (!reg.test(value)) {
          callback(
            new Error(
              'Area should consist of 9 digits only (For e.g.:  123456789)!',
            ),
          )
        } else if (value > 9999999) {
          callback(new Error('Area should less than or equals to 9999999!'))
        } else {
          callback()
        }
      } else if (rule.field === 'value') {
        const reg = /^(?!$)\d{1,9}(?:\\d{9})?$/
        if (!reg.test(value)) {
          callback(
            new Error(
              'Quantity should consist of 4 digits only (For e.g.:  1234)!',
            ),
          )
        } else if (value <= 0) {
          callback(
            new Error('Quantity should be greater than or equals to 1!'),
          )
        } else if (value > 9999) {
          callback(
            new Error('Quantity should be less than or equals to 9999!'),
          )
        } else {
          callback()
        }
      } else if (rule.field === 'label') {
        if (String(value).length > 100) {
          callback(
            new Error('Grouping must be less than or equals to 100 characters'),
          )
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      loading: true,
      list: [],
      form: {
        id: undefined,
        label: undefined,
        value: undefined,
        area: undefined,
        groupingBankId: undefined,
        tenantId: undefined,
        perimeter: undefined,
        screenId: undefined,
        structureProfileId: undefined,
      },
      rules: {
        label: [
          {
            required: true,
            message: 'Please Select/Enter Grouping',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        value: [
          { required: true, message: 'Please Enter Quantity', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
        area: [
          {
            required: true,
            message: 'Please Enter Area',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      gridOptions: null,
      columnDefs: [],
      frameworkComponents: null,
      width: '100%',
      height: '45em',
      visible: false,
      spinning: false,
      groupingBanks: this.grouping.dropdownData.bank_interior_grouping,
      closable: true,
      title: 'Add',
      enable: true,
      selectedRows: [],
      postSort: null,
      apiURL: undefined,
      bank: {
        id: undefined,
        name: undefined,
      },
      visibleSaveAsBank: false,
      visibleAdd: false,
      requestData: null,
      autoGroupColumnDef: null,
      pinnedBottomRowData: null,
    }
  },
  beforeMount() {
    this.visible = true
    this.postSort = rowNodes => {
      const sortedData = []
      for (let i = 0; i < rowNodes.length; i++) {
        sortedData.push(rowNodes[i].data)
      }
      this.list = [...sortedData]
    }
    this.loadingConfig()
  },
  mounted() {
    this.$root.$off('deleteInteriorGrouping')
    this.$root.$on('deleteInteriorGrouping', this.deleteBank)
    this.$root.$off('saveAsGrouping')
    this.$root.$on('saveAsGrouping', this.saveAsBank)
    this.$root.$off('updateGrouping')
    this.$root.$on('updateGrouping', this.onUpdate)
  },
  created() {
    this.getRowStyle = params => {
      if (params.node.rowPinned) {
        return { 'font-weight': 'bold' }
      }
    }
    this.pinnedBottomRowData = this.createData(0)
  },
  methods: {
    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        rowDragManaged: true,
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          resizable: true,
          menuTabs: ['filterMenuTab'],
        },
      }
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        toolTipRenderer: ToolTipRenderer,
        customFilter: CustomFilter,
        textEditor: TextEditor,
        inputNumberEditor: InputNumberEditor,
        numberRender: NumberRender,
      }
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
          cellStyle: params => {
            if (params.data.display === 'Total') {
              return {
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'none',
              }
            } else {
              return { textAlign: 'right' }
            }
          },
        },
        {
          field: '0',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
          cellStyle: params => {
            if (params.data['0'] === 'Total') {
              return {
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'none',
              }
            } else {
              return { textAlign: 'right' }
            }
          },
        },
        {
          headerName: 'Grouping',
          field: 'label',
          width: 500,
          filter: 'customFilter',
          headerTooltip: 'Grouping',
          cellStyle: params => {
            if (params.data.label === 'Total') {
              return {
                fontWeight: 'bold',
                textAlign: 'right',
                display: 'none',
              }
            }
          },
          cellRenderer: 'toolTipRenderer',
          cellEditor: 'textEditor',
          cellRendererParams: {
            searchType: 'string',
            type: 'interiorGrouping',
          },
          editable: params => {
            if (params.data.label === 'Total') {
              return false
            } else {
              return true
            }
          },
        },
        {
          headerName: 'Quantity',
          field: 'value',
          width: 200,
          filter: 'customFilter',
          headerTooltip: 'Grouping',
          cellRenderer: 'numberRender',
          cellEditor: 'inputNumberEditor',
          cellStyle: params => {
            if (params.data.value === 'Total') {
              return {
                fontWeight: 'bold',
                textAlign: 'center',
              }
            } else {
              return { textAlign: 'right' }
            }
          },
          headerClass: 'header-right',
          cellRendererParams: {
            searchType: 'string',
            type: 'interiorGrouping',
            placeholder: 'Quantity',
            precision: 0,
            min: 1,
            max: 999999999,
          },
          editable: params => {
            if (params.data.label === 'Total') {
              return false
            } else {
              return true
            }
          },
          pinnedRowCellRenderer: params => {
            return '<strong>' + 'Total Grouping Area' + '</strong>'
          },
        },
        {
          headerName: 'Area',
          field: 'area',
          width: 80,
          filter: 'customFilter',
          headerTooltip: 'Area',
          cellRenderer: 'numberRender',
          cellEditor: 'inputNumberEditor',
          cellStyle: params => {
            if (params.data.area === 'Total') {
              return { fontWeight: 'bold', textAlign: 'center' }
            } else {
              return { textAlign: 'right' }
            }
          },
          headerClass: 'header-right',
          cellRendererParams: {
            searchType: 'string',
            type: 'interiorGrouping',
            placeholder: 'Area',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          editable: params => {
            if (params.data.label === 'Total') {
              return false
            } else {
              return true
            }
          },
          pinnedRowCellRenderer: params => {
            return '<strong>' + params.data.area + '</strong>'
          },
        },
        {
          headerName: 'Perimeter',
          field: 'perimeter',
          width: 80,
          filter: 'customFilter',
          headerTooltip: 'Area',
          cellRenderer: 'numberRender',
          cellEditor: 'inputNumberEditor',
          cellStyle: params => {
            if (params.data.perimeter === 'Total') {
              return {
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'none',
              }
            } else {
              return { textAlign: 'right' }
            }
          },
          headerClass: 'header-right',
          cellRendererParams: {
            searchType: 'string',
            type: 'interiorGrouping',
            placeholder: 'Area',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          editable: true,
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 80,
          suppressSizeToFit: true,
          cellStyle: params => {
            if (params.data.action === 'Total') {
              return {
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'none',
              }
            } else {
              return { textAlign: 'center' }
            }
          },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'interiorGrouping',
            delete: true,
            save: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ]
    },

    onClose() {
      this.visible = false
      this.title = 'Add'
      this.groupingBanks = this.grouping.dropdownData.bank_interior_grouping
      this.closable = true
      this.enable = true
      this.visibleAdd = false
      this.form.groupingBankId = undefined
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.$emit('onClose', false)
    },

    onClear() {
      this.title = 'Add'
      this.closable = true
      this.spinning = false
      this.enable = true
      this.groupingBanks = this.grouping.dropdownData.bank_interior_grouping
      this.form.groupingBankId = undefined
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    onCancel() {
      this.onClear()
      this.visibleAdd = false
    },

    closeBank() {
      this.visibleSaveAsBank = false
      this.bank.id = undefined
      this.bank.name = undefined
    },

    onFilter(input) {
      const oldData = this.grouping.dropdownData.bank_interior_grouping
      if (input) {
        this.groupingBanks = oldData.filter(data => {
          if (data.option.toLowerCase().includes(input.toLowerCase())) {
            return data
          }
        })
      } else {
        this.groupingBanks = oldData
        this.enable = true
      }
    },

    onChange(value) {
      this.form.label = value
      const selectedData = this.grouping.dropdownData.bank_interior_grouping.find(
        i => i.option === value,
      )
      this.form.area = selectedData.area
      this.form.groupingBankId = selectedData.id
      this.$refs.label.onFieldBlur()
      this.$refs.area.onFieldBlur()
      this.enable = false
    },

    onLoad(params) {
      params.api.setColumnDefs(this.columnDefs)
      params.api.sizeColumnsToFit()
      const data = this.grouping.groupings
      const total = data.reduce((value, group) => {
        return (
          value +
          (group.value ? group.value : 0) * (group.area ? group.area : 0)
        )
      }, 0)
      this.pinnedBottomRowData = this.createData(total)
      params.api.setRowData(_.get(this.grouping, 'groupings', []))
      this.loading = false
    },

    onRowSelected() {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    onSelectionChanged() {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    deleteBank(record) {
      var that = this
      this.$confirm({
        title: `Are you sure you want to delete '${record.label}' ?`,
        content: h => (
          <div style="color:red">
            <p>
              This action will delete all information related to this tenant
              bank interior grouping.
            </p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(record)
        },
      })
    },

    deleteMultipleBanks() {
      var that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected interior grouping banks' ?`,
        content: h => (
          <div style="color:red">
            <p>
              This action will delete all information related to this tenant
              bank interior grouping.
            </p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
      })
    },

    confirmDelete(record) {
      this.loading = true
      this.closable = false
      const request = []
      let url
      if (record) {
        request.push({
          id: record.id,
          interiorGroupingId: record.interiorGroupId,
        })
      } else {
        this.selectedRows.forEach(element => {
          request.push({
            id: element.id,
            interiorGroupingId: element.interiorGroupId,
          })
        })
      }
      switch (this.grouping.screen) {
        case 'Common-Area':
          url = projectAPIs.project.asset.commonArea.grouping.delete(
            this.$route.params.id,
            this.grouping.assetId,
          )
          break
        case 'Site-Takeoff':
          url = projectAPIs.project.asset.siteTakeoff.grouping.delete(
            this.$route.params.id,
            this.grouping.assetId,
          )
          break
        case 'Interior-Info':
          this.form.tenantId = this.grouping.tenantId
          url = projectAPIs.project.asset.interiorInfo.grouping.delete(
            this.$route.params.id,
            this.grouping.assetId,
          )
          break

        default:
          break
      }
      instance
        .delete(url, { data: request })
        .then(response => {
          request.forEach(element => {
            const index = this.list.findIndex(i => i.id === element.id)
            this.list.splice(index, 1)
          })
          if (record) {
            this.gridOptions.api.applyTransaction({ remove: [record] })
          } else {
            this.gridOptions.api.applyTransaction({
              remove: this.selectedRows,
            })
          }
          this.gridOptions.api.deselectAll()
          this.calculateTotal(this.list)
          this.$emit('onClose', null, request, 'delete')
          this.closable = true
          this.loading = false
          this.selectedRowKeys = []
          this.selectedRows = []
        })
        .catch(err => {
          this.loading = false
          this.closable = true
          errorService(err)
        })
    },

    onSave() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.closable = false
          this.spinning = true
          let data = [...this.list]
          this.form.screenId = this.grouping.screenId
          this.form.perimeter = this.form.area
            ? calculatePerimeterBuildingFootprint(this.form.area)
            : undefined
          let url
          switch (this.grouping.screen) {
            case 'Common-Area':
              url = projectAPIs.project.asset.commonArea.grouping.add(
                this.$route.params.id,
                this.grouping.assetId,
              )
              break
            case 'Site-Takeoff':
              url = projectAPIs.project.asset.siteTakeoff.grouping.add(
                this.$route.params.id,
                this.grouping.assetId,
              )
              break
            case 'Interior-Info':
              this.form.tenantId = this.grouping.tenantId
              this.form.structureProfileId = this.grouping.structureProfileId
              url = projectAPIs.project.asset.interiorInfo.grouping.add(
                this.$route.params.id,
                this.grouping.assetId,
              )
              break

            default:
              break
          }
          instance
            .post(url, this.form)
            .then(response => {
              if (response.data.message) {
                this.closable = true
                this.spinning = false
                switch (response.data.message) {
                  case 'Interior grouping already exists.':
                  case 'Interior group already exists.':
                  case 'Interior grouping bank already exists. Please enter different name.':
                    showNotification(
                      'warning',
                      'Grouping',
                      response.data.message,
                    )
                    break
                  default:
                    showNotification(
                      'warning',
                      'Grouping',
                      response.data.message,
                    )
                    break
                }
              } else {
                const group = _.get(response.data, 'result', null)
                const grouping = {
                  id: _.get(group, 'id', undefined),
                  interiorGroupId: _.get(group, 'interiorGroupId', undefined),
                  tenantId: _.get(group, 'tenantId', undefined),
                  label: this.form.label,
                  value: this.form.value,
                  area: _.get(group, 'area', undefined),
                  perimeter: _.get(group, 'perimeter', undefined),
                  isValidTakeoff: group.isValidTakeoff,
                  conditionFactorId: _.get(
                    group,
                    'conditionFactorId',
                    undefined,
                  ),
                  constructionQualityFactorId: _.get(
                    group,
                    'constructionQualityFactorId',
                    undefined,
                  ),
                  takeoffs: [],
                }
                data = data.concat(grouping)
                this.list = [...data]
                this.gridOptions.api.redrawRows()
                const itemsToAdd = addGridRecord(grouping)
                this.gridOptions.api.applyTransaction({
                  add: itemsToAdd,
                })
                this.onClear()
                this.$emit('onClose', grouping, null, 'add')
                this.calculateTotal(this.list)
              }
            })
            .catch(error => {
              this.closable = true
              this.spinning = false
              errorService(error)
            })
        }
      })
    },

    onUpdate(value, record, key, index) {
      const currentValue = value === 0 ? value.toString() : !value ? '' : value
      const previousValue = !window.previousValue ? '' : window.previousValue
      if (
        currentValue !== null &&
        previousValue.toString() !== currentValue.toString()
      ) {
        this.closable = false
        this.loading = true
        let url
        let isValid = true
        const grouping = { ...record }
        const groupDetails = { ...record }
        switch (key) {
          case 'label':
            grouping.label = value
            break
          case 'value':
            isValid = validateNumber(value || 0, key, 'Quantity')
            if (isValid) {
              grouping.value = value
            }
            break
          case 'area':
            isValid = validateNumber(value, key, 'Area')
            if (isValid) {
              grouping.area = value
              grouping.perimeter = calculatePerimeterBuildingFootprint(
                value || 0,
              )
            }
            break
          case 'perimeter':
            isValid = validateNumber(value, key, 'perimeter')
            if (isValid) {
              grouping.perimeter = value
            }
            break
          default:
            break
        }
        if (isValid) {
          const request = {
            label: grouping.label,
            value: grouping.value,
          }
          switch (key) {
            case 'area':
              Object.assign(request, {
                area: value ? Number(value) : null,
                perimeter: grouping.perimeter,
              })
              break
            case 'perimeter':
              Object.assign(request, {
                perimeter: value ? Number(value) : null,
              })
              break

            default:
              Object.assign(request, {
                screenId: this.grouping.screenId,
              })
              break
          }
          switch (this.grouping.screen) {
            case 'Common-Area':
              switch (key) {
                case 'area':
                case 'perimeter':
                  url = projectAPIs.project.asset.commonArea.update(
                    this.$route.params.id,
                    this.grouping.assetId,
                    record.id,
                  )
                  break
                default:
                  url = projectAPIs.project.asset.commonArea.grouping.update(
                    this.$route.params.id,
                    this.grouping.assetId,
                    record.id,
                    record.interiorGroupId,
                  )
                  break
              }
              break
            case 'Site-Takeoff':
              switch (key) {
                case 'area':
                case 'perimeter':
                  url = projectAPIs.project.asset.siteTakeoff.update(
                    this.$route.params.id,
                    this.grouping.assetId,
                    record.id,
                  )
                  break
                default:
                  url = projectAPIs.project.asset.siteTakeoff.grouping.update(
                    this.$route.params.id,
                    this.grouping.assetId,
                    record.id,
                    record.interiorGroupId,
                  )
                  break
              }
              break
            case 'Interior-Info':
              switch (key) {
                case 'area':
                case 'perimeter':
                  url = projectAPIs.project.asset.interiorInfo.update(
                    this.$route.params.id,
                    this.grouping.assetId,
                    record.id,
                  )
                  break
                default:
                  Object.assign(request, {
                    tenantId: this.grouping.tenantId,
                    structureProfileId: this.grouping.structureProfileId,
                  })
                  url = projectAPIs.project.asset.interiorInfo.grouping.update(
                    this.$route.params.id,
                    this.grouping.assetId,
                    record.id,
                    record.interiorGroupId,
                  )
                  break
              }
              break

            default:
              break
          }
          instance
            .patch(url, request)
            .then(response => {
              const newData = [...this.list]
              newData[index] = grouping
              this.list = [...newData]
              this.gridOptions.api.redrawRows()
              const itemsToUpdate = updateGridRecord(
                this.gridOptions,
                grouping,
                newData[index],
              )
              this.gridOptions.api.applyTransaction({
                update: itemsToUpdate,
              })
              this.gridOptions.api.redrawRows()
              this.closable = true
              this.spinning = false
              this.loading = false
              this.calculateTotal(this.list)
              this.$emit('onClose', grouping, null, 'update', key)
            })
            .catch(err => {
              this.closable = true
              this.spinning = false
              this.loading = false
              this.resetRowData(groupDetails, index)
              errorService(err)
            })
        } else {
          this.closable = true
          this.loading = false
          this.resetRowData(groupDetails, index)
        }
      }
    },

    saveAsBank(record) {
      this.bank.id = record.interiorGroupId
      this.bank.name = `${record.label} - Copy`
      switch (this.grouping.screen) {
        case 'Common-Area':
          this.apiURL = projectAPIs.project.asset.commonArea.grouping.saveAs(
            this.$route.params.id,
            this.grouping.assetId,
            record.id,
            record.interiorGroupId,
          )
          break
        case 'Interior-Info':
          this.apiURL = projectAPIs.project.asset.interiorInfo.grouping.saveAs(
            this.$route.params.id,
            this.grouping.assetId,
            record.id,
            record.interiorGroupId,
          )
          break
        case 'Site-Takeoff':
          this.apiURL = projectAPIs.project.asset.siteTakeoff.grouping.saveAs(
            this.$route.params.id,
            this.grouping.assetId,
            record.id,
            record.interiorGroupId,
          )
          break
        default:
          break
      }
      this.visibleSaveAsBank = true
    },

    resetRowData(groupDetails, index) {
      const newData = [...this.list]
      newData[index] = groupDetails
      this.list = [...newData]
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateGridRecord(
        this.gridOptions,
        groupDetails,
        newData[index],
      )
      this.gridOptions.api.applyTransaction({ update: itemsToUpdate })
      this.gridOptions.api.redrawRows()
      const focusedCell = this.gridOptions.api.getFocusedCell()
      if (focusedCell) {
        this.gridOptions.api.setFocusedCell(focusedCell.rowIndex, 'value')
        this.gridOptions.api.startEditingCell({
          rowIndex: focusedCell.rowIndex,
          colKey: 'value',
        })
      }
      this.$emit('onClose', groupDetails, null, 'error')
    },

    sortChanged(node) {
      const isSortApplied = this.gridOptions.columnApi
        .getColumnState()
        .filter(
          i => i.colId !== 'action' && i.colId !== 'display' && i.colId !== '0',
        )
        .some(element => element.sort)
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'display',
            hide: isSortApplied,
          },
        ],
      })
    },

    filterChanged() {
      this.calculateTotal(this.list)
    },

    onRowDragEnd(e) {
      this.loading = true
      this.closable = false
      const request = []
      this.list.forEach((i, index) => {
        request.push({
          id: i.interiorGroupId,
          sequence: index + 1,
        })
      })
      this.reorder(request)
    },

    onRowDragLeave(e) {
      this.onRowDragEnd(e)
    },

    reorder(request) {
      let url
      switch (this.grouping.screen) {
        case 'Common-Area':
          url = projectAPIs.project.asset.commonArea.grouping.reorder(
            this.$route.params.id,
            this.grouping.assetId,
          )
          break
        case 'Site-Takeoff':
          url = projectAPIs.project.asset.siteTakeoff.grouping.reorder(
            this.$route.params.id,
            this.grouping.assetId,
          )
          break
        case 'Interior-Info':
          this.form.tenantId = this.grouping.tenantId
          url = projectAPIs.project.asset.interiorInfo.grouping.reorder(
            this.$route.params.id,
            this.grouping.assetId,
          )
          break

        default:
          break
      }
      instance
        .patch(url, request)
        .then(response => {
          this.loading = false
          this.closable = true
          this.onClear()
          this.selectedRowKeys = []
          this.gridOptions.api.deselectAll()
          this.$emit('onClose', this.list, null, 'sequence')
        })
        .catch(err => {
          this.loading = false
          this.closable = true
          errorService(err)
        })
    },

    calculateTotal(data) {
      const total = data.reduce((value, group) => {
        return (
          value +
          (group.value ? group.value : 0) * (group.area ? group.area : 0)
        )
      }, 0)
      this.pinnedBottomRowData = this.createData(total)
    },

    createData(area) {
      var result = []
      result.push({
        display: 'Total',
        label: 'Total',
        area: formatNumber(area),
        0: 'Total',
        value: 'Total',
        perimeter: 'Total',
        action: 'Total',
      })
      return result
    },
  },
}
